if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}


  document.getElementById('ModalClose-benefits-second').addEventListener('click', function() {
    var modal = document.getElementById('ScentIntensity');
    modal.removeAttribute('open');  // Close the modal
    document.body.classList.remove('overflow-hidden');  // Remove overflow-hidden from the body
  });

  document.getElementById('ModalClose-benefits').addEventListener('click', function() {
    var modal = document.getElementById('ScentIntensity');
    modal.removeAttribute('open');  // Close the modal
    document.body.classList.remove('overflow-hidden');  // Remove overflow-hidden from the body
  });

  // Optionally, add logic to open the modal and apply overflow-hidden
  function openModal() {
    var modal = document.getElementById('ScentIntensity');
    modal.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');  // Add overflow-hidden when the modal is opened
  }

